import { useQuery } from '@tanstack/react-query'
import { getCaseEvidence } from '@/services/api/caseEvidence'

/** Reverify access and source availability whenever a citation is opened. */
export function useCaseEvidence(caseId: string, referenceId: string) {
  return useQuery({
    queryKey: ['case-evidence', caseId, referenceId],
    queryFn: ({ signal }) => getCaseEvidence(caseId, referenceId, signal),
    staleTime: 0,
    gcTime: 0,
    retry: false,
    refetchOnMount: 'always',
  })
}
